'use client';
import { useState } from 'react';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';
import Cookies from "js-cookie";
import Config from '../Config';



function Allimagestyle({ selectedImageId, setSelectedImageId ,uploadedImages,setUploadedImages}) {



  const onDrop = async (acceptedFiles) => {
    const newImages = acceptedFiles.map((file, index) => ({
      id: Date.now() + index, // temporary ID
      url: URL.createObjectURL(file),
      uploading: false,
      start:true,
    }));
  
    setUploadedImages((prev) => [...prev, ...newImages]);
  
    setTimeout(() => {
      (async () => {

 
    for (let i = 0; i < acceptedFiles.length; i++) {
      const file = acceptedFiles[i];
      const formData = new FormData();
      formData.append('image', file);
  
      try {
        const res = await axios.post(`${Config.apiurl}/api/v1/common/image-upload`, formData, {
          headers: { 'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${Cookies.get("a_token")}`
           },
        });
  
        setUploadedImages((prev) =>
          prev.map((img) =>
            img.url === newImages[i].url
              ? {
                  id: res.data.data._id,
                  url: res.data.data.fileUrl,
                  uploading: true,
                  start:false,
                }
              : img
          )
        );
        
        setSelectedImageId((prev) => {
          const exists = prev.some((item) => item.id === res.data.data._id);
          if (!exists) {
            return [...prev, { id: res.data.data._id, url: res.data.data.fileUrl }];
          }
          return prev;
        });
      } catch (error) {
        console.error('Upload failed:', error);
      }
    }

  })();
  },2000)
  };

  

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    multiple: true,
    accept: {
      'image/png': ['.png'],
      'image/jpeg': ['.jpeg', '.jpg'],
      'image/webp': ['.webp'],
    },
  });

  const handleSelectImage = (img) => {
    setSelectedImageId((prev) =>
      prev.some((selected) => selected.id === img.id)
        ? prev.filter((selected) => selected.id !== img.id)
        : [...prev, img]
    );
  };

  return (
    <div className='input-container_img_div_im_head'>
        <div className="w-full input-container_img_div_im">
        

        {/* Dropzone Area */}
        {/* <div className="marjet_house_pic_up"> */}
        <div
            {...getRootProps()}
            className={`border-2 border-dashed rounded-lg p-6 text-center transition duration-300  marjet_house_pic_up_edit${
            isDragActive ? 'border-green-400 bg-green-50' : 'border-gray-300'
            } hover:border-blue-400 cursor-pointer`}
        >
            <input {...getInputProps()} />
            <img src="/img/image.png" alt="Upload" className="mx-auto mb-2 w-12 h-12" />
        
        </div>
        




        </div>
    </div>
  );
}

export default Allimagestyle;
